import { _ as K, a as B, b as oe, c as I, d as me } from "./TermsModal-CBEOKaIP.js";
import { e as Ot, f as Ht, g as Wt, h as Ut, i as Gt, j as Jt, k as Qt, l as Xt, m as Zt, n as en, o as tn } from "./TermsModal-CBEOKaIP.js";
import { defineComponent as h, resolveComponent as C, unref as p, openBlock as l, createBlock as b, createSlots as ae, withCtx as _, createVNode as m, createCommentVNode as k, computed as c, createElementBlock as v, Fragment as P, createElementVNode as y, toValue as ve, defineAsyncComponent as M, resolveDynamicComponent as fe, renderSlot as f, toDisplayString as w, renderList as A, watch as $, normalizeProps as ye, guardReactiveProps as be, useModel as T, onMounted as _e, mergeModels as V, normalizeClass as L, withDirectives as he, vModelRadio as ke, createTextVNode as ge, ref as re, withModifiers as xe } from "vue";
import { useProviderI18n as x, extractProviderKey as we, usePaymentPlanService as Ce, reportSessionError as $e, formatLocalDate as Pe, fullDaysBetween as Se, useApplicationStore as ie, useFieldStore as De, useProviderStore as le } from "@versatile-credit-apply/sdk";
import { mapValues as Ke } from "lodash-es";
import { useI18n as Ie } from "vue-i18n";
import { useIsInStore as Me } from "@versatile-credit-apply/composition";
import { A as on, _ as an, T as rn, V as ln } from "./index-NNo9Bf-Y.js";
import { useDebounceFn as Ae } from "@vueuse/core";
import { _ as se } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { useScopedRegle as Te } from "@regle/core";
import { requiredIf as Ve } from "@regle/rules";
import { faCircleCheck as Be, faCircle as Le } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as R } from "@fortawesome/vue-fontawesome";
import Re from "@ui-kit/components/button";
import Ee from "@ui-kit/components/drawer";
import { useRoute as ce } from "vue-router";
import { _ as cn } from "./TermsModalLink-BxJnmPaT.js";
const S = /* @__PURE__ */ h({
  __name: "DisclosureContact",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(t) {
    const e = t, { te: n } = x(() => e.providerKey);
    return (o, a) => {
      const r = C("i18n-t");
      return p(n)("contact") ? (l(), b(r, {
        key: 0,
        keypath: "contact",
        tag: "p"
      }, ae({ _: 2 }, [
        t.providerKey ? {
          name: "lender",
          fn: _(() => [
            m(K, { "provider-key": t.providerKey }, null, 8, ["provider-key"])
          ]),
          key: "0"
        } : void 0,
        t.providerKey ? {
          name: "lenderLong",
          fn: _(() => [
            m(K, {
              "provider-key": t.providerKey,
              "display-type": "long"
            }, null, 8, ["provider-key"])
          ]),
          key: "1"
        } : void 0,
        t.providerKey ? {
          name: "website",
          fn: _(() => [
            m(r, {
              keypath: "contact_website",
              tag: "span"
            })
          ]),
          key: "2"
        } : void 0,
        t.providerKey ? {
          name: "bankDefault",
          fn: _(() => [
            m(p(B), { "provider-key": t.providerKey }, null, 8, ["provider-key"])
          ]),
          key: "3"
        } : void 0,
        t.providerKey ? {
          name: "bankShort",
          fn: _(() => [
            m(p(B), {
              "provider-key": t.providerKey,
              "display-type": "short"
            }, null, 8, ["provider-key"])
          ]),
          key: "4"
        } : void 0
      ]), 1024)) : k("", !0);
    };
  }
});
function E(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "synchrony_standard_en",
    resource: {
      contact: { t: 0, b: { t: 2, i: [{ t: 3, v: "You authorize " }, { t: 4, k: "lender" }, { t: 3, v: " to contact you at each phone number you have provided. By providing a cell phone number you agree to receive 1) account updates and information and 2) account security alerts, including text messages from " }, { t: 4, k: "lender" }, { t: 3, v: ". Message frequency varies. Message & data rates may apply. Text HELP for help, text STOP to Opt-Out. Terms & Conditions and Privacy Policy: " }, { t: 4, k: "website" }, { t: 3, v: `.
` }] } },
      contact_website: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "www.synchrony.com" } }
    }
  });
}
function F(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "tdbank_standard_en",
    resource: {
      contact: { t: 0, b: { t: 2, i: [{ t: 3, v: "When you give us your mobile phone number, we have your permission to contact you at that number about all of your " }, { t: 4, k: "lenderLong" }, { t: 3, v: ` accounts. Your consent allows us to use text messaging, artificial or pre-recorded voice messages and automatic dialling technology for informational and account service calls, but not for telemarketing or sales calls. It may include contact from companies working on our behalf to service your accounts. Message and data rates may apply. You may contact us anytime to change these preferences.
` }] } }
    }
  });
}
function N(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "ads_standard_en",
    resource: {
      contact: { t: 0, b: { t: 2, i: [{ t: 3, v: "By providing a mobile number or a number later converted to a mobile number, you agree that " }, { t: 4, k: "bankShort" }, { t: 3, v: ", " }, { t: 4, k: "bankDefault" }, { t: 3, v: ` and their service providers may contact you regarding your accounts at that number, including by autodialer, recorded or artificial voice, and text. Message and data rates may apply.
` }] } }
    }
  });
}
typeof E == "function" && E(S);
typeof F == "function" && F(S);
typeof N == "function" && N(S);
const g = /* @__PURE__ */ h({
  __name: "DisclosureIncome",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(t) {
    const e = t, { te: n } = x(() => e.providerKey), o = c(
      () => n(`${e.vertical}.income`) ? `${e.vertical}.income` : "income"
    );
    return (a, r) => {
      const i = C("i18n-t");
      return l(), v(P, null, [
        m(i, {
          keypath: o.value,
          tag: "p"
        }, ae({
          wi_note: _(() => [
            m(i, {
              tag: "span",
              class: "font-medium",
              keypath: "wi_note"
            })
          ]),
          wi_disclaimer: _(() => [
            m(i, {
              tag: "span",
              keypath: "wi_disclaimer"
            })
          ]),
          br: _(() => [
            r[0] || (r[0] = y("br", null, null, -1))
          ]),
          _: 2
        }, [
          t.providerKey ? {
            name: "lender",
            fn: _(() => [
              m(K, { "provider-key": t.providerKey }, null, 8, ["provider-key"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["keypath"]),
        p(n)("income_line_2") ? (l(), b(i, {
          key: 0,
          class: "font-bold",
          keypath: "income_line_2",
          tag: "p"
        }, {
          wi_disclaimer: _(() => [
            m(i, {
              class: "font-normal",
              keypath: "wi_disclaimer",
              tag: "span"
            })
          ]),
          _: 1
        })) : k("", !0)
      ], 64);
    };
  }
});
function Y(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3, v: "Alimony, child support or separate maintenance income need not be included unless relied upon for credit. You may include the monthly amount that you have available to spend from your assets. " }, { t: 4, k: "wi_note" }, { t: 3, v: " " }, { t: 4, k: "wi_disclaimer" }, { t: 3, v: `
` }] } },
      wi_disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `If you are applying for an individual account and your spouse also is a WI resident, combine your and your spouse's financial information.
` } },
      wi_note: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `MARRIED WI Residents only:
` } }
    }
  });
}
function q(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "aff_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation.
` } }
    }
  });
}
function z(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "easypay_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3, v: "Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation. For information regarding " }, { t: 4, k: "lender" }, { t: 3, v: `'s Programs, visit www.easypayfinance.com/programs.
` }] } }
    }
  });
}
function j(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "snap_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation. If you include non-taxable income/benefits, increase them by 20%.
` } }
    }
  });
}
function O(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "synchrony_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3, v: 'Your "Net Income" includes what you earn or reasonably expect to earn from employment, investments, retirement, social security benefits and public assistance. You can also include money that someone else deposits regularly into your account (individual or joint) and the amount that you have available to spend from your assets. If you are 21 or over, you may also include the amount of someone else’s income that is regularly used to pay your expenses. Alimony, child support or separate maintenance income need not be included unless relied upon for credit. ' }, { t: 4, k: "wi_note" }, { t: 3, v: `: If this is an individual account, please also include your spouse’s income.
` }] } },
      wi_note: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WI Residents Only" } }
    }
  });
}
function H(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "progressive_standard_en",
    resource: {
      income: { t: 0, b: { static: "", t: 2, i: [] } }
    }
  });
}
function W(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "fortiva_standard_dell_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `*Alimony; child support or separate maintenance income need not be included if you do not wish to have it considered as a basis for repaying this obligation.
` } },
      income_line_2: { t: 0, b: { t: 2, i: [{ t: 3, v: "Wisconsin Married Residents: " }, { t: 4, k: "wi_disclaimer" }, { t: 3, v: `
` }] } },
      wi_disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Combine your and your spouse's information." } }
    }
  });
}
function U(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "tdbank_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Alimony, child support, or separate maintenance income need not be revealed if  you do not wish to have it considered as a basis for repaying your obligation. Your total gross annual income is what you earn or reasonably expect to earn  from work, self-employment, interest, dividends, investments, social security  or other benefits. You can also include money that someone else regularly  deposits into your banking account and if you are 21 or older you can include  income from others that you regularly use to pay your bills.
` } }
    }
  });
}
function G(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "ads_standard_en",
    resource: {
      retail: {
        income: { t: 0, b: { t: 2, i: [{ t: 3, v: "Alimony, child support or separate maintenance income need not be included unless relied upon for credit. You may include the monthly amount that you have available to spend from your assets. " }, { t: 4, k: "wi_note" }, { t: 3, v: " " }, { t: 4, k: "wi_disclaimer" }, { t: 3, v: " " }, { t: 4, k: "br" }, { t: 3, v: " " }, { t: 4, k: "br" }, { t: 3, v: ` Income is not provided to all lenders until you decide to proceed with a full application.
` }] } }
      }
    }
  });
}
typeof Y == "function" && Y(g);
typeof q == "function" && q(g);
typeof z == "function" && z(g);
typeof j == "function" && j(g);
typeof O == "function" && O(g);
typeof H == "function" && H(g);
typeof W == "function" && W(g);
typeof U == "function" && U(g);
typeof G == "function" && G(g);
const ue = /* @__PURE__ */ h({
  __name: "DisclosureBankCard",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(t) {
    const e = t, { te: n } = x(() => e.providerKey);
    return (o, a) => {
      const r = C("i18n-t");
      return p(n)("bank_card") ? (l(), b(r, {
        key: 0,
        keypath: "bank_card",
        tag: "p"
      })) : k("", !0);
    };
  }
});
function J(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "aff_standard_en",
    resource: {
      bank_card: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Prepaid cards are not accepted.
` } }
    }
  });
}
typeof J == "function" && J(ue);
const Fe = (t) => {
  const e = ve(t);
  if (e == null)
    return;
  const n = typeof e == "string" ? e : e.providerKey;
  return n != null ? we(n) : void 0;
}, Ne = (t, e) => {
  const n = Ke(
    e,
    (o) => M(o)
  );
  return c(() => {
    const o = Fe(t);
    return o ? n[o] : void 0;
  });
}, Ye = /* @__PURE__ */ h({
  __name: "DisclosurePrequalify",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(t) {
    const e = t, n = Ne(() => e.providerKey, {
      synchrony_standard: () => import("./SynchronyDisclosurePrequalify-D6h8uifD.js"),
      ads_standard: () => import("./AdsDisclosurePrequalify-B4JP7i9h.js"),
      snap_standard: () => import("./SnapDisclosurePrequalify-HqAvcTWR.js")
    });
    return (o, a) => (l(), b(fe(p(n)), { "provider-key": t.providerKey }, null, 8, ["provider-key"]));
  }
}), qe = { key: 0 }, Lt = /* @__PURE__ */ h({
  __name: "DisclosureDictionary",
  props: {
    providerKey: {},
    type: {},
    applyMode: { default: "full" },
    vertical: {}
  },
  setup(t) {
    const e = t, n = c(() => e.type === "contact"), o = c(() => e.type === "income"), a = c(() => e.type === "bank-card"), r = c(
      () => e.type === "prequalify-disclosure" && e.applyMode == "prequalify"
    ), i = c(
      () => n.value || o.value || a.value || r.value
    );
    return (u, s) => i.value ? (l(), v("div", qe, [
      f(u.$slots, "footnote"),
      n.value ? (l(), b(S, {
        key: 0,
        "provider-key": t.providerKey,
        "apply-mode": t.applyMode
      }, null, 8, ["provider-key", "apply-mode"])) : o.value ? (l(), b(g, {
        key: 1,
        "provider-key": t.providerKey,
        "apply-mode": t.applyMode,
        vertical: t.vertical
      }, null, 8, ["provider-key", "apply-mode", "vertical"])) : a.value ? (l(), b(ue, {
        key: 2,
        "provider-key": t.providerKey,
        "apply-mode": t.applyMode
      }, null, 8, ["provider-key", "apply-mode"])) : r.value ? (l(), b(Ye, {
        key: 3,
        "provider-key": t.providerKey,
        "apply-mode": t.applyMode
      }, null, 8, ["provider-key", "apply-mode"])) : k("", !0)
    ])) : k("", !0);
  }
}), ze = { class: "contents" }, je = { class: "font-medium sm:justify-self-end" }, Oe = /* @__PURE__ */ h({
  __name: "ErrorDetailsField",
  props: {
    label: {},
    value: {}
  },
  setup(t) {
    return (e, n) => (l(), v("div", ze, [
      y("div", je, w(t.label) + ":", 1),
      y("div", null, w(t.value), 1)
    ]));
  }
}), He = {
  key: 0,
  class: "grid grid-cols-1 justify-start gap-3 p-2 sm:p-4 bg-surface-100 text-sm border-gray-300 text-gray-600 sm:grid-cols-[max-content_1fr] rounded-lg border"
}, We = /* @__PURE__ */ h({
  __name: "ErrorDetails",
  props: {
    error: {}
  },
  setup(t) {
    const { t: e } = Ie(), n = t, o = Me(), a = c(() => {
      const r = [];
      return n.error?.trackingId && r.push({
        label: e("errors.field.tracking_id.label"),
        value: n.error.trackingId
      }), o.value && n.error?.code && r.push({
        label: e("errors.field.code.label"),
        value: n.error.code
      }), o.value && n.error?.details && r.push({
        label: e("errors.field.details.label"),
        value: n.error.details
      }), r;
    });
    return (r, i) => a.value.length ? (l(), v("div", He, [
      (l(!0), v(P, null, A(a.value, (u, s) => (l(), b(Oe, {
        key: s,
        label: u.label,
        value: u.value
      }, null, 8, ["label", "value"]))), 128))
    ])) : k("", !0);
  }
});
function Q(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      errors: {
        field: {
          code: {
            label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Error Code" } }
          },
          details: {
            label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Error Details" } }
          },
          tracking_id: {
            label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Tracking ID" } }
          }
        },
        general: {
          instructions: { t: 0, b: { t: 2, i: [{ t: 3, v: "Please contact your " }, { t: 4, k: "merchantName" }, { t: 3, v: " associate." }] } },
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "An unexpected error occurred." } }
        }
      }
    }
  });
}
typeof Q == "function" && Q(We);
const Rt = M(
  () => import("./ModalLauncherButton-BUbuxVfi.js")
), Et = M(
  () => import("./ConfirmExitFlowButton-CrsxcGA2.js")
), Ue = { class: "text-center" }, de = /* @__PURE__ */ h({
  __name: "PlanSummaryTab",
  props: {
    offer: {},
    vertical: {},
    active: { type: Boolean }
  },
  setup(t) {
    const e = t, n = c(() => ({
      id: `offer-tab-${e.offer.providerKey}-${e.offer.productType}`,
      class: [
        // Size
        "h-[75px]",
        "max-h-[75px]",
        "md:h-[68px]",
        "md:max-h-[68px]",
        "w-[132px]",
        "md:w-[320px]",
        "max-w-[320px]",
        // Padding
        "px-4",
        "py-2",
        // Makes the Tab and Tab-Body appear as a single item
        "-mb-[1px]",
        // Border
        "border",
        {
          "border-surface-300 border-b-surface-400": !e.active,
          "border-surface-400 border-b-transparent": e.active
        },
        "bg-surface-0",
        "rounded-t-2xl",
        "transition-all",
        // Layout
        "grid",
        "grid-cols-1",
        "grid-rows-[20px_1fr]",
        "md:grid-cols-2",
        "md:grid-rows-1",
        "gap-1",
        "justify-items-center"
      ]
    })), { te: o } = x(() => e.offer.providerKey), a = c(() => o(`approval-heading.${e.offer.productType}`) ? `approval-heading.${e.offer.productType}` : "approval-heading.credit"), r = Ce(), i = Ae(async () => {
      try {
        await r.publishPlansPresented([e.offer.providerKey]);
      } catch (u) {
        $e(u);
      }
    }, 500);
    return $(
      () => e.active,
      (u) => {
        u && i();
      }
    ), $(
      () => e.offer,
      () => {
        e.active && i();
      }
    ), (u, s) => {
      const d = C("i18n-t");
      return l(), v("div", ye(be(n.value)), [
        f(u.$slots, "logo", {}, () => [
          m(p(oe), {
            class: "logo h-max-[20px] md:h-max-[52px] h-full max-w-[112px] md:max-w-full",
            provider: t.offer.providerKey,
            vertical: t.vertical
          }, null, 8, ["provider", "vertical"])
        ], !0),
        y("div", Ue, [
          m(d, {
            keypath: a.value,
            tag: "p",
            class: "text-sm"
          }, null, 8, ["keypath"]),
          t.offer.response.approvedAmountCents ? (l(), b(p(I), {
            key: 0,
            value: t.offer.response.approvedAmountCents,
            class: "text-sm font-bold md:text-2xl",
            whole: ""
          }, null, 8, ["value"])) : k("", !0)
        ])
      ], 16);
    };
  }
});
function X(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      "approval-heading": {
        credit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Credit Limit:
` } },
        lease: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Lease up to:
` } },
        loan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Loan up to:
` } }
      }
    }
  });
}
typeof X == "function" && X(de);
const Ge = /* @__PURE__ */ se(de, [["__scopeId", "data-v-de0a69f6"]]), Je = { class: "flex flex-row gap-0.5" }, Ft = /* @__PURE__ */ h({
  __name: "PlanSummaryTabs",
  props: /* @__PURE__ */ V({
    offers: {},
    vertical: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = T(t, "modelValue"), o = (a) => {
      n.value = a;
    };
    return _e(() => {
      n.value == null && e.offers.length && (n.value = e.offers[0]);
    }), (a, r) => (l(), v("div", Je, [
      (l(!0), v(P, null, A(t.offers, (i) => (l(), b(Ge, {
        key: `tab-${i.id}`,
        class: "cursor-pointer",
        offer: i,
        active: n.value?.id === i.id,
        vertical: t.vertical,
        onClick: (u) => o(i)
      }, {
        logo: _(() => [
          f(a.$slots, "logo", { offer: i })
        ]),
        _: 2
      }, 1032, ["offer", "active", "vertical", "onClick"]))), 128))
    ]));
  }
}), Qe = {
  key: 0,
  class: "space-y-4 p-4"
}, Xe = { class: "flex flex-col gap-4" }, Nt = /* @__PURE__ */ h({
  __name: "PlanSummaryTabBody",
  props: /* @__PURE__ */ V({
    active: { type: Boolean },
    offer: {},
    selectable: { type: Boolean },
    purchaseAmount: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = T(t, "modelValue"), o = c({
      get() {
        return n?.value?.providerPlanCode;
      },
      set(a) {
        a == null ? n.value = void 0 : n.value = e.offer.plans.find(
          (r) => r.providerPlanCode === a
        );
      }
    });
    return Te(
      {
        selectedPlanCode: o
      },
      {
        selectedPlanCode: {
          required: Ve(() => e.selectable && e.active)
        }
      }
    ), (a, r) => t.active ? (l(), v("div", Qe, [
      f(a.$slots, "header", { offer: t.offer }),
      y("div", Xe, [
        (l(!0), v(P, null, A(t.offer.plans, (i) => (l(), v("div", {
          key: i.providerPlanCode
        }, [
          f(a.$slots, "plan", {
            offer: t.offer,
            plan: i,
            selectable: !!t.selectable,
            selectedPlanCode: o.value,
            selectPlan: (u) => o.value = u
          })
        ]))), 128))
      ]),
      f(a.$slots, "footer", { offer: t.offer })
    ])) : k("", !0);
  }
}), Ze = ["id", "aria-selected", "aria-label"], et = ["for"], tt = ["id", "name", "value", "aria-labelledby"], nt = { class: "flex grow flex-col items-center gap-4 bg-surface-0 p-4 md:flex-row" }, ot = { class: "logo h-auto w-35 min-w-35" }, at = { class: "legal-font-size flex grow flex-col" }, rt = { class: "mb-2 font-semibold text-primary-600" }, it = /* @__PURE__ */ h({
  __name: "PlanCard",
  props: /* @__PURE__ */ V({
    plan: {},
    vertical: {},
    selectable: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = T(t, "modelValue"), n = t, o = c(
      () => `payment-plan-${n.plan.providerKey}-${n.plan.providerPlanCode}`
    ), a = c(
      () => `${n.plan.providerKey}-${n.plan.providerPlanCode}`
    ), r = c(
      () => `${a.value}-${n.plan.providerPlanCode}`
    ), i = c(() => e.value === n.plan.providerPlanCode), u = () => {
      n.selectable && (e.value = i.value ? void 0 : n.plan.providerPlanCode);
    };
    return (s, d) => (l(), v("div", {
      id: a.value,
      key: r.value,
      "aria-selected": i.value && t.selectable,
      "aria-label": t.plan.title,
      class: L([{
        "cursor-pointer grid-cols-[max-content_1fr]": t.selectable,
        "border-surface-600 bg-surface-0": !i.value || !t.selectable,
        "border-primary-600 bg-primary-600": i.value && t.selectable
      }, "plan-card-container grid overflow-hidden rounded-md border transition-colors"]),
      onClick: u
    }, [
      t.selectable ? (l(), v("div", {
        key: 0,
        class: L([{
          "border-r-surface-600": !i.value,
          "border-r-primary-600 bg-primary-600": i.value
        }, "grid h-full flex-col items-center border-r px-1 transition-colors"])
      }, [
        y("label", { for: o.value }, [
          i.value ? (l(), b(p(R), {
            key: 0,
            icon: p(Be),
            class: "text-surface-0",
            size: "lg"
          }, null, 8, ["icon"])) : (l(), b(p(R), {
            key: 1,
            icon: p(Le),
            size: "lg"
          }, null, 8, ["icon"]))
        ], 8, et),
        he(y("input", {
          id: o.value,
          "onUpdate:modelValue": d[0] || (d[0] = (D) => e.value = D),
          name: o.value,
          value: t.plan.providerPlanCode,
          "aria-labelledby": a.value,
          class: "hidden",
          type: "radio"
        }, null, 8, tt), [
          [ke, e.value]
        ])
      ], 2)) : k("", !0),
      y("div", null, [
        f(s.$slots, "banner", { plan: t.plan }, void 0, !0),
        y("div", nt, [
          y("div", ot, [
            f(s.$slots, "logo", { plan: t.plan }, () => [
              m(p(oe), {
                class: "logo h-max-[20px] md:h-max-[52px] h-full max-w-[112px] md:max-w-full",
                provider: t.plan.providerKey,
                vertical: t.vertical
              }, null, 8, ["provider", "vertical"])
            ], !0)
          ]),
          y("div", at, [
            f(s.$slots, "title", { plan: t.plan }, () => [
              y("p", rt, w(t.plan.title), 1)
            ], !0),
            f(s.$slots, "content", { plan: t.plan }, void 0, !0)
          ]),
          f(s.$slots, "payment", { plan: t.plan }, void 0, !0)
        ])
      ])
    ], 10, Ze));
  }
}), Yt = /* @__PURE__ */ se(it, [["__scopeId", "data-v-93f892b1"]]), lt = { class: "grid min-h-20 min-w-44 grid-rows-[max-content] place-content-center gap-1 text-nowrap rounded-lg bg-surface-200 px-8 py-3 text-center text-base" }, st = /* @__PURE__ */ h({
  __name: "PlanPayment",
  props: {
    plan: {}
  },
  setup(t) {
    const e = t;
    return x(() => e.plan.providerKey), (n, o) => {
      const a = C("i18n-t");
      return l(), v("div", lt, [
        f(n.$slots, "payment", {}, () => [
          m(a, {
            keypath: "payment",
            tag: "p",
            "aria-labelledby": `${t.plan.providerPlanCode}-title ${t.plan.providerPlanCode}-paymentSuggestion`
          }, {
            value: _(() => [
              m(p(I), {
                value: t.plan.monthlyAmountCents ?? 0
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["aria-labelledby"])
        ]),
        f(n.$slots, "learnHowDrawer", { plan: t.plan })
      ]);
    };
  }
});
function Z(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      payment: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `/mo
` }] } }
    }
  });
}
typeof Z == "function" && Z(st);
const ct = ["id"], ut = ["id"], dt = { key: 2 }, pt = /* @__PURE__ */ h({
  __name: "PlanCardAttribute",
  props: {
    attribute: {},
    plan: {}
  },
  setup(t) {
    const e = t, { t: n } = x(() => e.plan.providerKey), o = c(() => n(`attributes.${e.attribute}.label`)), a = c(
      () => e.plan[e.attribute] != null
    ), r = (s) => s === "firstPaymentDate" || s === "expireDateTime", i = (s, d, D) => n(
      `attributes.${s}.value`,
      {
        value: d
      },
      {
        plural: D
      }
    ), u = c(() => {
      const s = e.attribute, d = e.plan[s];
      return s === "apr" ? d : typeof d == "number" ? i(s, d, d) : typeof d == "string" && r(s) ? i(
        s,
        Pe(d),
        Math.max(Se(/* @__PURE__ */ new Date(), d), 0)
      ) : d;
    });
    return (s, d) => a.value ? (l(), v("div", {
      key: t.attribute,
      class: "grid grid-cols-[160px_minmax(0,1fr)] text-xs md:text-base"
    }, [
      y("p", {
        id: `${t.attribute}-label`,
        class: "font-medium"
      }, [
        f(s.$slots, "title", {}, () => [
          ge(w(o.value), 1)
        ])
      ], 8, ct),
      y("p", {
        id: `${t.attribute}-value`,
        class: "place-self-start"
      }, [
        f(s.$slots, "value", {}, () => [
          t.attribute === "apr" ? (l(), b(p(me), {
            key: 0,
            value: u.value
          }, null, 8, ["value"])) : t.attribute.includes("Cents") ? (l(), b(p(I), {
            key: 1,
            value: u.value,
            whole: !1
          }, null, 8, ["value"])) : (l(), v("span", dt, w(u.value), 1))
        ])
      ], 8, ut)
    ])) : k("", !0);
  }
});
function ee(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      attributes: {
        apr: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `APR:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `%
` }] } }
        },
        downPaymentCents: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Initial Payment:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `
` }] } }
        },
        durationMonths: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Term:
` } },
          value: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " Month" }] }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: ` Months
` }] }] } }
        },
        expireDateTime: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Approval Expires:
` } },
          value: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: " (" }, { t: 4, k: "count" }, { t: 3, v: " day)" }] }, { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: " (" }, { t: 4, k: "count" }, { t: 3, v: ` days)
` }] }] } }
        },
        financedAmountCents: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Amount Financed:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `
` }] } }
        },
        termMonths: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Term:
` } },
          value: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " Month" }] }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: ` Months
` }] }] } }
        },
        totalCostCents: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Total Amount:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `
` }] } }
        }
      }
    }
  });
}
typeof ee == "function" && ee(pt);
const mt = { key: 0 }, vt = /* @__PURE__ */ h({
  __name: "PlanDrawer",
  props: {
    plan: {}
  },
  setup(t) {
    const e = t, { t: n } = x(() => e.plan.providerKey), o = re(!1);
    function a() {
      o.value = !0;
    }
    return (r, i) => {
      const u = Ee, s = Re;
      return t.plan ? (l(), v("div", mt, [
        m(u, {
          visible: o.value,
          "onUpdate:visible": i[0] || (i[0] = (d) => o.value = d),
          position: "right",
          "block-scroll": "",
          class: "w-full max-w-[600px]"
        }, {
          header: _(() => [...i[1] || (i[1] = [
            y("p", { class: "w-full" }, null, -1)
          ])]),
          default: _(() => [
            f(r.$slots, "content", {
              plan: t.plan,
              isVisible: o.value
            })
          ]),
          _: 3
        }, 8, ["visible"]),
        m(s, {
          label: p(n)("open_label"),
          text: "",
          class: "text-nowrap !py-0",
          onClick: xe(a, ["stop"])
        }, null, 8, ["label"])
      ])) : k("", !0);
    };
  }
});
function te(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      open_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Learn How" } }
    }
  });
}
typeof te == "function" && te(vt);
const ne = {
  id: "default",
  steps: ["applicant", "terms", "decision"]
}, ft = {
  id: "review-and-accept-offer",
  steps: ["reviewOffer", "terms", "decision"]
}, yt = () => {
  const t = ie(), e = De(), n = le();
  return c(() => {
    const o = n.currentProviderKey;
    return o && t.previousResponses.find(
      (r) => r.next?.provider?.providerKey === o
    )?.next?.applyMode === "prescreen" && e.fieldCount === 0 ? ft : ne;
  });
};
function bt(t, e) {
  return typeof t == "object" && !!t[e];
}
const pe = (t) => {
  const e = ce(), n = ie();
  return c(() => {
    const o = e.meta?.step;
    return o ? typeof o == "string" ? o : typeof o == "function" ? o(t.value.map((r) => r.id)) : n.applyMode && bt(o, n.applyMode) ? o[n.applyMode] : o["*"] : void 0;
  });
}, _t = (t) => {
  const { t: e } = t, n = yt(), o = (a) => ({
    id: a,
    label: (r) => e(`stepper.steps.${r}.label`)
  });
  return c(() => n.value.steps.map(o));
}, ht = (t) => {
  const e = le(), n = re(0), o = pe(t);
  return $(o, (a, r) => {
    a && r && (n.value = t.value.findIndex(
      (i) => i.id === a
    ));
  }), $(
    () => e.currentProviderKey,
    () => {
      n.value = 0;
    }
  ), c(() => n.value);
}, kt = (t) => {
  const e = ht(t), n = pe(t);
  return c(() => {
    const o = n.value;
    return o ? t.value.findIndex((a) => a.id === o) : e.value;
  });
}, qt = (t) => {
  const e = _t(t), n = kt(e), o = ce();
  return c(() => o.meta?.hideStepper ? [] : e.value.map((a, r) => n.value === r ? {
    ...a,
    status: "active"
  } : n.value > r ? {
    ...a,
    status: "complete"
  } : {
    ...a,
    status: "inactive"
  }));
};
export {
  on as ApplicationFooter,
  Ot as CheckDetails,
  Et as ConfirmExitFlowButton,
  I as Currency,
  Ht as CurrencyHero,
  Wt as CurrencyPerPeriod,
  Lt as DisclosureDictionary,
  Ut as DownloadContentButton,
  oe as DynamicProviderLogo,
  We as ErrorDetails,
  Gt as IconHero,
  Jt as LenderAccountName,
  B as LenderBankName,
  K as LenderName,
  Rt as ModalLauncherButton,
  me as Percent,
  Yt as PlanCard,
  pt as PlanCardAttribute,
  vt as PlanDrawer,
  st as PlanPayment,
  Nt as PlanSummaryTabBody,
  Ft as PlanSummaryTabs,
  an as ProviderApplicationDocuments,
  Qt as ProviderDecisionDataTable,
  Xt as RequiredNote,
  Zt as TermsModal,
  cn as TermsModalLink,
  rn as TermsViewer,
  ln as VersatilePrivacyPolicyLink,
  en as ViewTitle,
  tn as defineProviderDecisionTable,
  Ne as useLocalizedComponents,
  qt as useStepperSteps
};
//# sourceMappingURL=index.es.js.map
